import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle';

/**
 * SidebarController
 * @class
 * @description Manages sidebar toggle, submenus consistency and search filtering
 */
export default class SidebarController {
  constructor() {
    this.body = document.body;
    this.sidebar = document.querySelector('.sidebar');
  }

  init() {
    if (!this.sidebar) return;
    this._bindEvents();
    this._updateSidebarState();
  }

  _bindEvents() {
    // Toggle Sidebar via Menu Icon or Switch
    this.body.addEventListener('click', event => {
      const menuToggle = event.target.closest('#menuToggle');
      if (menuToggle) {
        this.body.classList.toggle('sidebar-collapsed');
        this._updateSidebarState();
      }
    });

    this.body.addEventListener('change', event => {
      if (event.target.id === 'toggleSidebar') {
        if (event.target.checked) {
          this.body.classList.remove('sidebar-collapsed');
        } else {
          this.body.classList.add('sidebar-collapsed');
        }
        this._updateSidebarState();
      }
    });

    // Search Filtering
    document.addEventListener('input', e => {
      if (e.target && e.target.id === 'sidebarSearch') {
        this._filterMenu(e.target.value);
      }
    });
  }

  _updateSidebarState() {
    const isCollapsed = this.body.classList.contains('sidebar-collapsed');
    const chevronIcon = document.querySelector('#chevronIcon');
    const toggleSidebarSwitch = document.querySelector('#toggleSidebar');
    const submenus = document.querySelectorAll('.sidebar .collapse');

    if (chevronIcon) {
      chevronIcon.innerText = isCollapsed
        ? 'keyboard_double_arrow_right'
        : 'keyboard_double_arrow_left';
    }

    if (toggleSidebarSwitch) {
      toggleSidebarSwitch.checked = !isCollapsed;
    }

    submenus.forEach(collapseEl => {
      const parentLink = document.querySelector(`a[href="#${collapseEl.id}"]`);

      if (isCollapsed) {
        if (collapseEl.classList.contains('show')) {
          collapseEl.setAttribute('data-was-open', 'true');
          const bsCollapse =
            bootstrap.Collapse.getInstance(collapseEl) ||
            new bootstrap.Collapse(collapseEl, { toggle: false });
          bsCollapse.hide();
          if (parentLink) parentLink.setAttribute('aria-expanded', 'false');
        }
      } else if (collapseEl.getAttribute('data-was-open') === 'true') {
        collapseEl.removeAttribute('data-was-open');
        const bsCollapse =
          bootstrap.Collapse.getInstance(collapseEl) ||
          new bootstrap.Collapse(collapseEl, { toggle: false });
        bsCollapse.show();
        if (parentLink) parentLink.setAttribute('aria-expanded', 'true');
      }
    });
  }

  _filterMenu(searchTerm) {
    const term = searchTerm.toLowerCase().trim();
    const navItems = document.querySelectorAll('#irmenu .nav-item');

    navItems.forEach(item => {
      const mainLink = item.querySelector(':scope > a');
      const mainSpan = mainLink ? mainLink.querySelector('span') : null;
      const mainText = mainSpan ? mainSpan.textContent.toLowerCase() : '';

      const subItemsList = item.querySelectorAll('.nav-collapse li');
      const matchesMain = mainText.includes(term);

      let hasMatchingSubItem = false;

      subItemsList.forEach(sub => {
        const subSpan = sub.querySelector('.sub-item');
        const subText = subSpan.textContent.toLowerCase();
        const matchesSub = subText.includes(term);

        if (term === '') {
          sub.style.display = '';
          this._highlightText(subSpan, '');
        } else if (matchesMain) {
          sub.style.display = '';
          this._highlightText(subSpan, matchesSub ? term : '');
        } else if (matchesSub) {
          sub.style.display = '';
          this._highlightText(subSpan, term);
          hasMatchingSubItem = true;
        } else {
          sub.style.display = 'none';
          this._highlightText(subSpan, '');
        }
      });

      if (mainSpan) this._highlightText(mainSpan, matchesMain ? term : '');

      const shouldShow = term === '' || matchesMain || hasMatchingSubItem;

      if (shouldShow) {
        item.style.display = '';
        if (term !== '' && item.classList.contains('submenu')) {
          const collapseEl = item.querySelector('.collapse');
          if (collapseEl && !collapseEl.classList.contains('show')) {
            const bsCollapse = bootstrap.Collapse.getOrCreateInstance(collapseEl);
            bsCollapse.show();
          }
        }
      } else {
        item.style.display = 'none';
      }
    });
  }

  _highlightText(element, term) {
    const text = element.textContent;
    if (!term) {
      element.innerHTML = text;
      return;
    }
    const regex = new RegExp(`(${term})`, 'gi');
    element.innerHTML = text.replace(regex, '<span class="search-highlight">$1</span>');
  }
}
